import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

/**
 * Applies a user's locked UI language from ui_preferences (e.g. Arabic-only
 * branch executives). Runs on login / refresh when the session user loads.
 */
export function usePreferredLanguage() {
  const { i18n } = useTranslation();
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const preferred = user?.ui_preferences?.language;
    if (!preferred) {
      return;
    }

    if (i18n.language !== preferred) {
      i18n.changeLanguage(preferred);
    }

    document.documentElement.lang = preferred;
    document.documentElement.dir = preferred === 'ar' ? 'rtl' : 'ltr';
  }, [isAuthenticated, user?.id, user?.ui_preferences?.language, i18n]);
}
